<template>
	<div class="list">
		<table class="list__table table-main">
			<thead>
				<tr>
					<th>번호</th>
					<th>등록일시</th>
					<th>브랜드명</th>
					<th>1차 카테고리</th>
					<th>2차 카테고리</th>
					<th>3차 카테고리</th>
					<th>제품명</th>
					<th>시작일</th>
					<th>종료일</th>
					<th>관리자명</th>
					<th>상태</th>
					<th>수정</th>
					<th>통계</th>
					<th>삭제</th>
				</tr>
			</thead>
			<tbody>
				<tr v-if="productList.length === 0" class="list__table__empty">
					<td colspan="13">
						<i class="fa fas fa-exclamation-circle" />
						<span>검색 결과가 없습니다</span>
					</td>
				</tr>
				<tr v-for="product in productList" :key="product.id">
					<td>{{ product.id }}</td>
					<td>
						{{ getDateTime(product.createdAt, 'YYYY-MM-DD HH:mm') }}
					</td>
					<td>{{ product.brandTitle }}</td>
					<td>{{ product.firstCategoryText }}</td>
					<td>{{ product.secondCategoryText }}</td>
					<td>{{ product.thirdCategoryText }}</td>
					<td>{{ product.productTitle }}</td>
					<td>
						{{ getDateTime(product.startOn, 'YYYY-MM-DD HH:mm') }}
					</td>
					<td>
						{{ getDateTime(product.endOn, 'YYYY-MM-DD HH:mm') }}
					</td>
					<td>{{ product.nickName }}</td>
					<td>{{ getStatusText(product.status) }}</td>
					<td>
						<button
							@click="modifyItem(product.id)"
							class="btn blue"
						>
							수정
						</button>
					</td>
					<td>
						<button
							class="btn blue"
							@click="
								$router.push({
									path: `/prouct/editor-product/statistics/${product.id}`,
								})
							"
						>
							통계
						</button>
					</td>
					<td>
						<button
							@click="removeItem(product.id)"
							class="btn blue bordered"
						>
							삭제
						</button>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>
<script>
	import moment from 'moment';

	export default {
		name: 'EditorProductTable',
		props: {
			productList: {
				type: Array,
				required: true,
			},
		},
		methods: {
			getDateTime(item, format) {
				if (item && typeof item === 'number') {
					return moment(item * 1000).format(format);
				} else {
					return '-';
				}
			},
			getStatusText(code) {
				return {
					ready: '전시예정',
					open: '전시중',
					closed: '비전시',
					undefined: '-',
				}[code];
			},
			modifyItem(id) {
				this.$emit('modify', { id });
			},
			removeItem(id) {
				this.$emit('remove', { id });
			},
		},
	};
</script>
<style lang="scss" scoped>
	.list__table {
		margin-bottom: 24px;

		.btn {
			display: inline-block;
		}
	}

	.fa {
		vertical-align: bottom;
	}
</style>
